export const parseIntFromInput = ({ target }) => {
	const input = target.value;
	const value = parseInt(input, 10);
	return Number.isNaN(value) ? input : value;
};
